import { toast, ToastOptions } from "react-toastify";

/**
 * 오류 토스트 억제 스위치. 밀려남 처리(`handleLoginSuperseded`)가 진행되는 동안 켠다 — 밀려난 화면에서 실패한
 * 요청마다 오류 토스트가 뜨는 대신, 로그인 화면의 밀려남 안내 하나로 통지한다(웹 스펙 `exclusive-login`).
 * 억제 중 새 `error` 통지는 무시하고 `success`·`info` 는 그대로 띄운다. 이미 떠 있는 토스트는 억제와 별개로
 * `dismissAllNotices()` 가 닫는다.
 *
 * 억제는 이 모듈의 `notice("error", …)` 에만 닿는다 — `toast.error` 를 직접 부르면 억제를 우회해 밀려남 처리
 * 중에도 뜬다. 그래서 오류 토스트는 `notice` 로 띄운다(지금 앱 코드에 `toast.error` 를 직접 부르는 곳은 없다).
 */
let errorNoticesMuted = false;

/**
 * 이후의 오류 토스트를 억제한다 — `notice("error", …)` 로 띄우는 통지만 막고, 직접 부른 `toast.error` 는 막지
 * 못한다. 이미 떠 있는 토스트는 건드리지 않는다(닫기는 `dismissAllNotices()`).
 */
export const muteErrorNotices = (): void => {
  errorNoticesMuted = true;
};

/** 오류 토스트 억제를 푼다. 그 뒤의 오류 통지는 정상으로 보인다. */
export const unmuteErrorNotices = (): void => {
  errorNoticesMuted = false;
};

/**
 * 지금 떠 있는 토스트를 모두 닫는다 — 종류(`success`·`info` 포함)와 무관하고, `notice` 로 띄우지 않은 토스트도
 * 닫는다. 억제 스위치는 건드리지 않는다.
 */
export const dismissAllNotices = (): void => {
  toast.dismiss();
};

const notice = (
  status: "success" | "error" | "info",
  text: string,
  options?: ToastOptions
) => {
  const toastOptions = options ?? {};

  if (status === "success") {
    return toast.success(text, toastOptions);
  } else if (status === "error") {
    if (errorNoticesMuted) return;
    return toast.error(text, toastOptions);
  } else if (status === "info") {
    return toast.info(text, toastOptions);
  }
};

export default notice;
